import { useState, useEffect } from 'react'
import '../inquiry/telephonic/telephonic.scss'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../components/button/Button'
import { setFormEditBranchId } from '../../store/slice/branch/branch.slice'
import { useNavigate } from 'react-router-dom'
import { numbers, permissions, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { FilterMatchMode, FilterService } from 'primereact/api'
import { TriStateCheckbox } from 'primereact/tristatecheckbox'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import PopupBox from '../../components/popup/PopupBox'
import managebtn from '../../assets/icons/managebtn.svg'
import HorizontalLine from '../../assets/icons/Line33.svg'
import pencilicon from '../../assets/icons/pencil1.svg'
import ArchiveIcon from '../../assets/icons/archive.svg'
import '../course/viewCourseList.scss'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { Box, Typography } from '@mui/material'
import closeIcon from '../../assets/icons/close.svg'
import { ErrorMessage, Formik } from 'formik'
import * as Yup from 'yup'
import RightDrawer from '../../components/drawer/Drawer'
import NewInput from '../../components/input/NewInput'
import './branch.scss'
import Calendar from '../../components/calendar/Calendar'
import {
  capitalizeFirstLetter,
  convertDateFormatCalendar,
  dynamicCustomFilter,
  generateDropdownOptions,
  handleInput,
  handleInputStringWithNum,
  handlePassword,
} from '../../utility/genricFunction'
import { archiveBranch, createBatch, getAllCourse } from '../../store/builders/branch/branch.builder'
import ModalUnstyled from '../../components/model/Model'
import { createBranchClassroom, getBranch } from '../../store/builders/branch/branch.builder'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'
import UseAuthorization from '../../utility/useAuthorization'
import Loader from '../../components/loader/Loader'
import apiClient from '../../services/axois'
import MultiSelectDropdown from '../../components/multi-select-dropdown/MultiSelectDropdown'
import CustomTabs from '../../components/Tabs/Tabs'
import BatchForm from './form/BatchForm'
import BatchTable from './table/BatchTable'

const Branch = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { courses } = useSelector((state) => state.branch)
  const roleSelector = useSelector((store) => store.auth)
  const userRole = roleSelector?.user?.result?.userData?.roleName

  const { loading, branchTableData } = useSelector((state) => state.branch)

  const userData = useSelector((store) => store?.auth?.user?.result?.userData)

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'branchName': { value: null, matchMode: 'dynamic_custom' },
    'branchEmail': { value: null, matchMode: 'dynamic_custom' },
    'branchPhone': { value: null, matchMode: 'dynamic_custom' },
    'country.name': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'representative': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'status': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'verified': { value: null, matchMode: FilterMatchMode.EQUALS },
    'addressLine': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'fulladdress': { value: null, matchMode: 'dynamic_custom' },
  })

  const [open, setOpen] = useState(false)
  const [openBatchModal, setOpenBatchModal] = useState(false)
  const [batchOpen, setBatchOpen] = useState(false)
  const [openArchive, setOpenArchive] = useState(false)
  const [classNoState] = useState('')
  const [classNameState] = useState('')
  const [branchData, setBranchData] = useState({})
  const [batchList, setBatchList] = useState([])
  const [selectedBatch, setSelectedBatch] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [filterNumber] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [archiveId, setArchiveId] = useState('')

  const handleArchive = (branchId) => {
    setOpenArchive(true)
    setIsOpen(true)
    setArchiveId(branchId)
  }

  useEffect(() => {
    dispatch(getAllCourse())
    dispatch(getBranch())
    setSelectedBatch([])
    return () => dispatch({ type: 'branch/clearExtraReducers' })
  }, [])
  const toggleDrawer = (newOpen) => {
    setOpen(newOpen)
    setIsOpen(true)
  }

  useEffect(() => {
    setFilteredData(branchTableData)
  }, [branchTableData])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(branchTableData, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  function handleClassroomFormSubmit(values) {
    const classRoomObj = {
      branchId: values.branch,
      branchClassroom: [
        {
          classNo: values.classNumber,
          className: values.className,
        },
      ],
    }
    dispatch(createBranchClassroom({ classRoomObj, setOpen }))
    // setOpen(false)
    setBatchOpen(false)
  }

  const toggleBatchDrawer = (newOpen) => {
    setBatchOpen(newOpen)
    setIsOpen(true)
  }

  const handleBatchDropdown = (event) => {
    setSelectedBatch(event)
  }

  const handleBranchArchive = (branchId) => {
    dispatch(archiveBranch({ branchId, dispatch, toast }))
  }

  const classRoomSchema = Yup.object().shape({
    branch: Yup.string().required(VALIDATION_MESSAGES.BRANCH_REQUIRED),
    classNumber: Yup.string().required(VALIDATION_MESSAGES.CLASS_NUMBER),
    className: Yup.string().required(VALIDATION_MESSAGES.CLASS_NAME),
  })

  const branch = generateDropdownOptions(branchTableData, 'branchName', 'branchId')

  const DrawerList = (
    <Box className='timetable-drawer' role='presentation'>
      <Box className='timetable-drawer-header flex justify-between align-center'>
        <Typography className='timetable-drawer-title'>{UI_CONSTANT.BRANCH.MANAGE_CLASSROOM}</Typography>
        <img
          className='timetable-drawer-icon'
          src={closeIcon}
          alt='Close'
          onClick={() => {
            toggleDrawer(false)
          }}
        />
      </Box>
      <Box className='drawer-horizontal-line' />

      <Formik
        initialValues={{
          branch: branchData.branchId,
          classNumber: classNoState,
          className: classNameState,
        }}
        validationSchema={classRoomSchema}
        onSubmit={(values) => {
          handleClassroomFormSubmit(values)
        }}
      >
        {({ values, handleChange, handleSubmit }) => (
          <form>
            <div className='full-form'>
              <div className='first-row'>
                <div className='first-field'>
                  <label className='branch-inp' htmlFor=''>
                    {UI_CONSTANT.BRANCH.LABEL_BRANCH}
                    <span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    options={branch}
                    selectedValue={values.branch}
                    className={'branch-dropdown'}
                    onChange={handleChange}
                    name={'branch'}
                    placeholder={'Select branch'}
                  />
                  <ErrorMessage name='branch' component='div' className='error-msg' />
                </div>
                <NewInput
                  label='Class Number'
                  placeholder='Enter class number'
                  name='classNumber'
                  width={'49%'}
                  type={'text'}
                  required={true}
                  onInput={handleInput}
                />
              </div>
              <div className='drawer-sec-row'>
                <NewInput
                  label='Class Name'
                  placeholder='Enter class name'
                  name='className'
                  width={'49%'}
                  required={true}
                  onInput={handleInputStringWithNum}
                />
              </div>
            </div>

            <div className='right-drawer-save'>
              <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                {UI_CONSTANT.SUBMIT}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </Box>
  )

  const verifiedBodyTemplate = (branchTableData) => {
    const handleRowClick = (id) => {
      const path = ROUTES_PATH.BRANCH_EDIT.replace(':id', id)
      navigate(path)
    }
    const getBatchOptionList = async (branchId) => {
      const url = `/batchesByBranchId?branchId=${branchId}`

      const response = await apiClient.get(url)
      const batches = response.data.result.batches.map((batch) => {
        return {
          value: batch.batchId,
          label: batch.batchNo,
        }
      })
      return batches
    }
    const handleCompleteBatches = async (data) => {
      const url = `/completebatch`
      try {
        const response = await apiClient.post(url, { batchIds: data })
        if (response?.data?.status) {
          setOpenBatchModal(false)
          toast.success(response.data.message, {
            className: 'custom-toast-success',
            progressStyle: { background: '#ffffff' },
          })
        }
      } catch (error) {
        toast.error(error.response.data.message)
        throw error
      }
    }
    const handleBatchList = async (id) => {
      setOpenBatchModal(true)
      let batchOptions = await getBatchOptionList(id)
      setBatchList(batchOptions)
    }
    const branchDotCondition = userRole == UI_CONSTANT.ADMIN_ROLE ? true : userData.branchId == branchTableData.branchId
    return (
      <>
        {branchDotCondition && (
          <>
            <PopupBox rowData={branchTableData} setIsOpen={setIsOpen} isOpen={isOpen}>
              <div className='popupbox'>
                {(UseAuthorization(permissions.MANAGE_CLASSROOM) && (
                  <p className='verifiedBodyTemplate-Assign'>ACTION</p>
                )) ||
                  (UseAuthorization(permissions.MANAGE_BATCH) && <p className='verifiedBodyTemplate-Assign'>ACTION</p>)}

                {UseAuthorization(permissions.MANAGE_CLASSROOM) && (
                  <button
                    className='div-assign-to-branch '
                    disabled={branchTableData?.branchStatus == 'archive' ? true : false}
                    onClick={() => {
                      setBranchData({
                        branchId: branchTableData.branchId,
                        branchName: branchTableData.branchName,
                      })
                      toggleDrawer(true)
                    }}
                  >
                    <img src={managebtn} alt='' />
                    <p
                      className={`${branchTableData?.branchStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                    >
                      Manage Classroom
                    </p>
                  </button>
                )}

                {UseAuthorization(permissions.MANAGE_BATCH) && (
                  <button
                    className='div-assign-to-branch'
                    disabled={branchTableData?.branchStatus == 'archive' ? true : false}
                    onClick={() => {
                      // toggleBatchDrawer(true)
                      navigate(`/manage-batch/${branchTableData.branchId}`)
                      setBranchData({
                        branchId: branchTableData.branchId,
                        branchName: branchTableData.branchName,
                      })
                    }}
                  >
                    <img src={managebtn} alt='' />
                    <p
                      className={`${branchTableData?.branchStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                    >
                      Manage Batch
                    </p>
                  </button>
                )}
                <button
                  className='div-assign-to-branch '
                  disabled={branchTableData?.branchStatus == 'archive' ? true : false}
                  onClick={() => handleBatchList(branchTableData.branchId)}
                >
                  <img src={managebtn} alt='' />
                  <p
                    className={`${branchTableData?.branchStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                  >
                    Complete Batch
                  </p>
                </button>
                <img src={HorizontalLine} alt='' />
                {UseAuthorization(permissions.EDIT_BRANCH) && (
                  <button
                    className='div-assign-to-branch'
                    disabled={branchTableData?.branchStatus == 'archive' ? true : false}
                    onClick={() => handleRowClick(branchTableData.branchId)}
                  >
                    <img src={pencilicon} alt='' />
                    <p
                      className={`${branchTableData?.branchStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                    >
                      Edit
                    </p>
                  </button>
                )}

                {UseAuthorization(permissions.ARCHIVE_BRANCH) && (
                  <button
                    className='div-assign-to-branch'
                    disabled={branchTableData?.branchStatus == 'archive' ? true : false}
                    onClick={() => handleArchive(branchTableData.branchId)}
                  >
                    <img src={ArchiveIcon} alt='' />
                    <p
                      className={`${branchTableData?.branchStatus == 'archive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                    >
                      Archive
                    </p>
                  </button>
                )}
              </div>
            </PopupBox>

            {openArchive && (
              <ModalUnstyled
                open={openArchive}
                setOpen={setOpenArchive}
                title={'Archive'}
                className={'archive-model'}
                backgroundColor='rgb(0 0 0 / 0.1)'
                BottomButton={'Yes'}
                BottomButton2={'No'}
                handleBranchArchive={() => {
                  handleBranchArchive(archiveId)
                }}
              >
                <div className='model-archive'>
                  <p>{UI_CONSTANT.ARCHIVE_MESSAGE}</p>
                </div>
              </ModalUnstyled>
            )}
            {openBatchModal && (
              <ModalUnstyled
                open={openBatchModal}
                setOpen={setOpenBatchModal}
                title={'Batch'}
                BottomButton={'Batch Complete'}
                handleAssignBranch={() => {
                  handleCompleteBatches(selectedBatch)
                }}
                className={'inventory-model'}
                backgroundColor='rgb(0 0 0 / 0.1)'
              >
                <MultiSelectDropdown
                  options={batchList}
                  selectedValue={selectedBatch}
                  className={'branch-drawer-option'}
                  onChange={(e) => handleBatchDropdown(e)}
                  name={'batchDropdown'}
                  placeholder={'Select batches'}
                />
              </ModalUnstyled>
            )}
          </>
        )}
      </>
    )
  }

  const addressBody = (branchTableData) => {
    return (
      <p>
        {capitalizeFirstLetter(branchTableData.addressLine)}, {branchTableData.areaName}, <br />{' '}
        {branchTableData.cityName}, {branchTableData.stateName}
      </p>
    )
  }
  const verifiedRowFilterTemplate = (options) => {
    return <TriStateCheckbox value={options.value} onChange={(e) => options.filterApplyCallback(e.value)} />
  }
  const nameBody = (branchTableData) => {
    const representative = branchTableData?.branchName && capitalizeFirstLetter(branchTableData?.branchName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'branchName',
      header: 'Branch',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'branchPhone',
      header: 'Phone',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by phone...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'branchEmail',
      header: 'Email',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by email...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,

      field: 'fulladdress',
      header: 'Address',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by address...',
      style: { minWidth: '12rem' },
      body: addressBody,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
      filterElement: verifiedRowFilterTemplate,
    },
  ]
  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.BRANCH.LABEL_BRANCH,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.BRANCH.LABEL_BRANCH,
      link: ROUTES_PATH.BRANCH,
    },
  ]
  return (
    <>
      {loading && <Loader loading={loading} />}
      {/* <div className={`telephonic-container flex flex-column`}> */}
      {<Loader loading={loading} /> && (
        <div className={`course-list }`}>
          <div className='filter-bar-wraper'>
            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />

              {UseAuthorization(permissions.ADD_BRANCH) && (
                <Button
                  className='add-btn'
                  onClick={() => {
                    navigate('/branch/add-branch')
                    dispatch(setFormEditBranchId(null))
                  }}
                >
                  {UI_CONSTANT.BRANCH.ADD_BRANCH}
                </Button>
              )}
            </div>
          </div>

          <div className='group-parent'>
            <div className='frame-wrapper'>
              <div className='course-list-wrapper'>
                <b className='course-list1'>{UI_CONSTANT.BRANCH.BRANCH_TABLE_HEADER}</b>
              </div>
            </div>
            <div className='flex page-drop-div'>
              <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
              <PageDropdown
                options={numbers}
                selectedValue={selectedNumber}
                onChange={(e) => setSelectedNumber(e.value)}
                className='w-full md:w-14rem small-dropdown'
              />
              <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
            </div>

            <div className={`table-card action-btn-include`}>
              <ParentDataTable
                value={filteredData}
                rows={filterNumber ? filteredData.length : selectedNumber}
                filters={filters}
                // loading={loading}
                // globalFilterFields={['name', 'country.name', 'representative.name', 'status']}
                columns={columns}
                archiveKey={'branchStatus'}
                onFilter={onFilter}
              />
            </div>
          </div>

          {open && (
            <RightDrawer
              anchor='right'
              isOpen={open}
              onClose={() => {
                toggleDrawer(false)
              }}
            >
              {DrawerList}
            </RightDrawer>
          )}
        </div>
      )}
    </>
  )
}

export default Branch
